import {ThunkAction} from 'redux-thunk';
import {Action} from 'redux';
import {IStore} from '../interface';
import {
  getNotificationCount,
  getNotifications,
  loadMoreNotifications,
  markAllNotificationsAsRead,
  markNotificationAsRead
} from '../pageAsyncActions';
import {clearErrorAction, finishLoadingAction, startLoadingAction} from '../status/actions';
import {
  setNotifications,
  appendNotifications,
  markNotificationRead,
  markAllNotificationsRead,
  resetNotifications,
  setNotificationCount
} from './actions';
import {errorHandler} from '../errorHandler';
import {ToastKey} from '../../components/gritx-toast/ToastKeyEnum';
import {getNotificationCountApi, getNotificationsApi, markAllNotificationsReadApi, markNotificationReadApi} from '../api/notifications';
import {IGetNotificationsParams} from './interfaces';

export const NOTIFICATIONS_PAGE_SIZE = 10;

export const loadNotificationsAction = (params: {
  indRead: boolean;
  offset: number;
  append: boolean;
}): ThunkAction<void, IStore, unknown, Action> => (
  async (dispatch, getState) => {
    const {
      auth: {auth0Client}
    } = getState();
    const isAuthenticated = await auth0Client.isAuthenticated();
    const actionKey = params.append ? loadMoreNotifications : getNotifications;

    if (isAuthenticated) {
      dispatch(startLoadingAction(actionKey));
      dispatch(clearErrorAction(actionKey));
      try {
        const apiParams: IGetNotificationsParams = {
          limit: NOTIFICATIONS_PAGE_SIZE,
          offset: params.offset / NOTIFICATIONS_PAGE_SIZE,
          indRead: params.indRead
        };
        const {data} = await getNotificationsApi(apiParams);

        dispatch(finishLoadingAction(actionKey));

        if (params.append) {
          dispatch(appendNotifications(data));
        } else {
          dispatch(setNotifications(data));
        }
      } catch (e) {
        console.log('loadNotificationsAction', e);
        dispatch(errorHandler({
          toastKey: ToastKey.LoadNotificationsAction,
          actionKey,
          error: e
        }));
      }
    }
  }
);

export const loadNotificationCountAction = ():
  ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {
      auth0Client
    }
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = getNotificationCount;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));

    try {
      const {data} = await getNotificationCountApi();

      dispatch(finishLoadingAction(actionKey));
      dispatch(clearErrorAction(actionKey));

      dispatch(setNotificationCount(data.value));
    } catch (e) {
      console.log('loadNotificationCountAction', e.message);
      dispatch(errorHandler({
        toastKey: ToastKey.GetNotificationCountAction,
        actionKey,
        error: e,
        currentAction: loadNotificationCountAction()
      }));
    }
  }
});

export const markNotificationReadAction = (notifId: number): ThunkAction<void, IStore, unknown, Action> => (
  async (dispatch, getState) => {
    const {
      auth: {auth0Client}
    } = getState();
    const isAuthenticated = await auth0Client.isAuthenticated();

    if (isAuthenticated) {
      const actionKey = markNotificationAsRead;

      dispatch(startLoadingAction(actionKey));
      try {
        await markNotificationReadApi(notifId);
        dispatch(markNotificationRead(notifId));
        loadNotificationCountAction();
        dispatch(finishLoadingAction(actionKey));
      } catch (e) {
        console.log('markNotificationReadAction', e);
        dispatch(errorHandler({
          toastKey: ToastKey.MarkNotificationReadAction,
          actionKey,
          error: e
        }));
      }
    }
  }
);

export const markAllNotificationsReadAction = (): ThunkAction<void, IStore, unknown, Action> => (
  async (dispatch, getState) => {
    const {
      auth: {auth0Client}
    } = getState();
    const isAuthenticated = await auth0Client.isAuthenticated();

    if (isAuthenticated) {
      const actionKey = markAllNotificationsAsRead;

      dispatch(startLoadingAction(actionKey));
      try {
        await markAllNotificationsReadApi();
        dispatch(markAllNotificationsRead());
        dispatch(finishLoadingAction(actionKey));
      } catch (e) {
        console.log('markAllNotificationsReadAction', e);
        dispatch(errorHandler({
          toastKey: ToastKey.MarkAllNotificationsReadAction,
          actionKey,
          error: e
        }));
      }
    }
  }
);

export const resetNotificationsAction = (): ThunkAction<void, IStore, unknown, Action> => (
  async (dispatch) => {
    dispatch(resetNotifications());
  }
);
